export { Input } from './Input';
export type { InputProps } from '@/types/components';

